import { Responsive } from '@cian/ui-kit';
import * as React from 'react';

import { ErrorContainer } from '../../../../containers/ErrorContainer';
import { MobileLayoutContainer } from '../MobileLayout';
import { TabletAndDesktopLayout } from '../TabletAndDesktopLayout';

interface IPageProps {
  isError?: boolean;
  recallFailed(): void;
}

export const Page: React.FC<IPageProps> = ({ recallFailed, isError }) => {
  return (
    <>
      <ErrorContainer recallFailed={recallFailed} isError={isError} />
      <Responsive phone>
        <MobileLayoutContainer key="MobileLayout" />
      </Responsive>
      <Responsive tablet desktop>
        <TabletAndDesktopLayout key="TabletAndDesktopLayout" />
      </Responsive>
    </>
  );
};
